import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import '../style/languageSwitcher.css';

function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Dropdown className="language-switcher">
      <Dropdown.Toggle variant="light" id="dropdown-language">
        {i18n.language === 'fr' ? 'FR' : 'EN'}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item 
          onClick={() => changeLanguage('en')} 
          active={i18n.language === 'en'}
        >
          {t('languageSwitcher.en')}
        </Dropdown.Item>
        <Dropdown.Item 
          onClick={() => changeLanguage('fr')} 
          active={i18n.language === 'fr'}
        >
          {t('languageSwitcher.fr')}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default LanguageSwitcher;
